<template>
  <v-row>
    <NewEditSchedule v-model="isNewEditScheduleDialogVisible"
                     :method="method"
                     :selected-schedule-id="selectedScheduleId"
                     @getSchedules="getSchedules()" />
    <v-col cols="12" class="d-flex justify-end py-0">
      <v-btn color="mainButtons"
             dark
             @click="showNewScheduleDialog()">
        {{ $t('general.newSchedule') }}
      </v-btn>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-data-table
        fixed-header
        :headers="tableHeaders"
        :height="dataTableHeight"
        :items="schedules"
        :loading="loadingSchedules"
        :options.sync="options"
        :footer-props="{
            'items-per-page-text': `${$t('general.schedules')} ${$t('general.perPage')}`,
            'items-per-page-options': [50, 100, 200]
          }"
        :server-items-length="totalSequencesSchedules"
        class="elevation-2 mt-4"
        :must-sort="false">
        <template v-slot:item="{ item }">
          <tr class="kbDarkBlueText--text">
            <td>
              <div>
                <span class="kbDarkBlueText--text font-weight-bold text-capitalize">
                  {{ item.name }}
                </span>
              </div>
            </td>

            <td>
              <div class="d-flex align-center">
                <v-btn :color="findDayInSchedule(item.dayAndHours, day.id) !== -1 ? 'kbGreen' : 'kbRed'"
                       class="mx-1"
                       dark
                       fab
                       height="38px"
                       style="cursor: default!important"
                       width="38px"
                       v-for="day in daysOfTheWeek"
                       :key="day.id">
                  <span class="white--text text-capitalize"
                        style="font-size: 13px!important">
                    {{ day.letter }}
                  </span>
                </v-btn>
              </div>
            </td>

            <td>
              <div class="text-center">
                <span class="kbDarkBlueText--text text-capitalize">
                  {{ convertTZToUserTZ(item.createdAt) | moment('MMMM Do YYYY') }}
                </span>
              </div>
            </td>

            <td>
              <div class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn color="kbDarkBlueText"
                           class="ml-1"
                           icon
                           @click="showEditScheduleDialog(item.id)"
                           v-on="on">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.editSchedule') }}</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-row>
            <v-col
              class="text-center"
              v-if="loadingSchedules"
              cols="12"
            >{{ $t('general.loading') }} {{ $t('general.schedules') }}</v-col>
            <v-col
              class="red--text text-center"
              v-else
              cols="12"
            >{{ $t('general.noSchedulesCreated') }}</v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'vue-moment'
import notifications from '@/libs/notifications'
import NewEditSchedule from '@/pages/App/Sequences/Schedules/dialogs/NewEditSchedule'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
import TimeZones from '@/mixins/TimeZones'
export default {
  components: { NewEditSchedule },
  computed: {
    ...mapGetters(['appUuid', 'companyUuid']),
    ...mapState({
      schedules: state => state.sequences.schedules,
      totalSequencesSchedules: state => state.sequences.totalSequencesSchedules
    }),
    tableHeaders () {
      return [
        { text: this.$t('general.scheduleName'), value: 'name', align: 'left', sortable: true },
        { text: this.$t('general.scheduleDays'), value: 'dayAndHours', align: 'left', sortable: false },
        { text: this.$t('general.creationDate'), value: 'createdAt', align: 'center', sortable: true },
        { text: this.$t('general.actions'), value: '', align: 'center', sortable: false }
      ]
    }
  },
  data () {
    return {
      daysOfTheWeek: [
        { letter: 'Mon', name: this.$t('general.monday'), id: 1 },
        { letter: 'Tue', name: this.$t('general.tuesday'), id: 2 },
        { letter: 'Wed', name: this.$t('general.wednesday'), id: 3 },
        { letter: 'Thu', name: this.$t('general.thursday'), id: 4 },
        { letter: 'Fri', name: this.$t('general.friday'), id: 5 },
        { letter: 'Sat', name: this.$t('general.saturday'), id: 6 },
        { letter: 'Sun', name: this.$t('general.sunday'), id: 7 }
      ],
      isDeleteScheduleDialogVisible: false,
      isNewEditScheduleDialogVisible: false,
      loadingSchedules: false,
      method: 'create',
      moment,
      options: {},
      selectedScheduleId: ''
    }
  },
  methods: {
    findDayInSchedule (scheduleDaysAndHours, dayId) {
      if (!scheduleDaysAndHours ||
        !Array.isArray(scheduleDaysAndHours) ||
        !scheduleDaysAndHours.length) {
        return -1
      }
      return scheduleDaysAndHours.map(item => item.dayOfTheWeek).indexOf(dayId)
    },
    async getSchedules () {
      try {
        this.loadingSchedules = true
        await this.$store.dispatch(
          'getSequencesSchedules',
          { appId: this.$store.getters.appUuid, pagination: this.options }
        )
        this.loadingSchedules = false
      } catch (e) {
        notifications.error(e)
        this.loadingSchedules = false
      }
    },
    showEditScheduleDialog (scheduleId) {
      this.method = 'edit'
      this.selectedScheduleId = scheduleId
      this.isNewEditScheduleDialogVisible = true
    },
    showNewScheduleDialog () {
      this.method = 'create'
      this.selectedScheduleId = ''
      this.isNewEditScheduleDialogVisible = true
    }
  },
  mixins: [ModuleTableHeight, TimeZones],
  watch: {
    options: {
      handler () {
        this.getSchedules()
      },
      deep: true
    }
  }
}
</script>
